import { render, staticRenderFns } from "./ReviewListing.vue?vue&type=template&id=c636f8a4&scoped=true"
import script from "./ReviewListing.vue?vue&type=script&lang=js"
export * from "./ReviewListing.vue?vue&type=script&lang=js"
import style0 from "./ReviewListing.vue?vue&type=style&index=0&id=c636f8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c636f8a4",
  null
  
)

export default component.exports